import { render, staticRenderFns } from "./PhoneIcon.vue?vue&type=template&id=5f4c5e28&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f4c5e28')) {
      api.createRecord('5f4c5e28', component.options)
    } else {
      api.reload('5f4c5e28', component.options)
    }
    module.hot.accept("./PhoneIcon.vue?vue&type=template&id=5f4c5e28&", function () {
      api.rerender('5f4c5e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/PhoneIcon.vue"
export default component.exports